import React from 'react';

import { Endpoint, Route } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import { HpmsCustomCardEvent, HpmsCustomCardMenuRenderEvent } from '@philips-emr/hpms-stipulator-components';
import { HPMSOnCreateMenu, HPMSOnOptionClick } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { Button, FetchAPI } from '@philips-emr/tws-components';
import { ButtonTheme, Placement } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnBeforeFetch, OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, ModalService } from '@philips-emr/tws-core/lib/services';
import { ModalProps } from '@philips-emr/tws-core/lib/services/modal-service';
import { applicationContext } from '@philips-emr/tws-foundation';
import { getBreakpoint } from '@philips-emr/tws-utils';

import { ConsultaInconsistenciaSibAliases as Aliases } from '../codegen';

import BaseController from './BaseController';

interface Data {
  ieIntercambio: string,
  nrSeqGuia: number,
  ieFuncaoAutorizador: number;
  ieVisualizadaEstip: string;
  cdPessoaFisica: string;
  nrSeqBeneficiario: number;
}

const OptionKey = {
  INCONSISTENCIAS: 'inconsistencias',
  ALTERARACAO: 'alteracao',

};

@Controller({ fragment: 'consulta-inconsistencia-sib' })
class ConsultaIncosistenciaSibController extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA)
  onFilterMount(event: MountEvent): void {
    const params = {
      dtInicio: null,
      dtFim: null,
    };
    FilterService.restoreFilterState(event, params);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnMount(Aliases.PANEL_INCONSISTENCIAS_SIB)
  onMountPanel(): void {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    void HttpService.post(Endpoint.POST.CONSISTIR_CONTRATO_SIB, { nrSeqContrato });
  }

  @OnBeforeFetch(Aliases.FETCH_CONSULTA)
  onBeforeFetch(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_VISUALIZACAO)
  onDynamicContentRenderVisualizacao(event: RenderEvent): void {
    const { data, render } = event;
    const { nrSeqBeneficiario } = data as unknown as Data;
    const breakpoints = getBreakpoint() as string;
    if (breakpoints == 'sm' || breakpoints == 'xsm') {
      return;
    }
    render(() => (

      <Button
        key="report"
        icon="/static/assets/view-details.svg"
        theme={ButtonTheme.QUIET_EMPHASIS}
        value=""
        iconPlacement={Placement.LEFT}
        onClick={() => this.modalInconsistencias(nrSeqBeneficiario)}
      />
    ));

  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_ALTERACAO)
  onDynamicContentRenderDetalhes(event: RenderEvent): void {
    const { data, render } = event;
    const { nrSeqBeneficiario, cdPessoaFisica } = data as unknown as Data;
    const breakpoints = getBreakpoint() as string;

    if (breakpoints == 'sm' || breakpoints == 'xsm') {
      return;
    }

    render(() => (

      <Button
        key="report"
        icon="/static/assets/report.svg"
        theme={ButtonTheme.QUIET_EMPHASIS}
        value=""
        iconPlacement={Placement.LEFT}
        onClick={() => this.alteracao(nrSeqBeneficiario, cdPessoaFisica)}
      />
    ));

  }

  @HPMSOnCreateMenu(Aliases.HPMS_CUSTOM_CARD)
  onCreateCardMenu(event: HpmsCustomCardMenuRenderEvent<Record<string, Value>>): void {
    const { shouldRender } = event;
    const breakpoints = getBreakpoint() as string;

    if (breakpoints == 'sm' || breakpoints == 'xsm') {
      shouldRender(true);
      return;
    }
    shouldRender(false);
  }

  @HPMSOnOptionClick(Aliases.HPMS_CUSTOM_CARD)
  onOptionClick(event: HpmsCustomCardEvent<Record<string, Value>>): void {
    const { key } = event;
    const { data } = event;
    const { nrSeqBeneficiario, cdPessoaFisica } = data as unknown as Data;

    const action = {
      [OptionKey.ALTERARACAO]: () => this.alteracao(nrSeqBeneficiario, cdPessoaFisica),
      [OptionKey.INCONSISTENCIAS]: () => this.modalInconsistencias(nrSeqBeneficiario),

    };

    if (action[key]) {
      action[key]();
    }
  }
  private alteracao(nrSeqBeneficiario: number, cdPessoaFisica: string): void {
    applicationContext.redirect(Route.BENEFICIARY_DATA, { nrSeqBeneficiario, cdPessoaFisica });
  }

  private modalInconsistencias(nrSeqBeneficiario: number): void {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();

    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: 'inconsistencias-sib',
      title: 'stipulator.inconsistencias',
      contextData: { nrSeqBeneficiario, nrSeqContrato },
    };
    ModalService.openDefault(modalWithFragment);

  }

}
export default ConsultaIncosistenciaSibController;
